import type { FC } from "react";
import { ASSISTANT_AVATAR } from "../../../../../theme/tokens";

const { FACE } = ASSISTANT_AVATAR;

interface HumanBustProps {
	skin: string;
	/** Scrubs color: the chosen body color's main stop. */
	scrubs: string;
}

/** Shoulders in scrubs with a V-neck, and the neck with its chin shadow. */
export const HumanBust: FC<HumanBustProps> = ({ skin, scrubs }) => (
	<>
		<path d="M14 126 C16 101 36 92 60 92 C84 92 104 101 106 126 Z" fill={scrubs} />
		<path d="M50 93 L60 105 L70 93 Z" fill={skin} />
		<path d="M50 93 L60 105 L70 93" fill="none" stroke={FACE.FOLD_LINE} strokeWidth={1.4} />
		<path d="M51 76 H69 V94 Q60 100 51 94 Z" fill={skin} />
		<path d="M51 82 Q60 89 69 82 V78 H51Z" fill={FACE.SKIN_SHADE} />
	</>
);
